export const FETCH_POSTBOXES_PENDING = 'FETCH_POSTOFFICES_PENDING';
export const FETCH_POSTBOXES_FULFILLED = 'FETCH_POSTOFFICES_FULFILLED';
export const FETCH_POSTBOXES_FAILED = 'FETCH_POSTOFFICES_FAILED';
